import Address from '@/utils/Address'
import merge from 'deepmerge'

export default class Person {
  constructor (officer) {
    if (officer) {
      if (officer.name_elements) {
        this.firstName = officer.name_elements.forename
        this.lastName = officer.name_elements.surname
      } else this.name = officer.name
      this.initDob(officer.date_of_birth)
      this.address = new Address(officer.address)
    } else {
      this.initDob()
      this.address = new Address()
    }
  }

  get name () {
    return this.lastName ? this.lastName + ', ' + this.firstName : this.firstName
  }

  set name (nm) {
    const name = nm.split(',').map(s => s.trim())
    this.firstName = name.length > 1 ? name[1] : name[0]
    this.lastName = name.length > 1 ? name[0] : ''
  }

  initDob (dobObj) {
    const emptyDOB = {year: '', month: '', day: ''}
    this.dobObj = dobObj ? merge(emptyDOB, dobObj) : emptyDOB
  }

  get isCompany () {
    if (typeof this.isCompanyVal !== 'undefined') return this.isCompanyVal
    else if (this.firstName) {
      this.isCompany = this.firstName.endsWith(' LTD') || this.firstName.endsWith(' LIMITED') || this.firstName.endsWith(' LLP')
    } else this.isCompany = false
    return this.isCompany
  }

  set isCompany (b) {
    this.isCompanyVal = b
  }

  static getDobString (p) {
    if (p.dateOfBirth) return [p.dateOfBirth.getDate(), p.dateOfBirth.getMonth() + 1, p.dateOfBirth.getFullYear()].join('-')
    else return Object.values(p.dobObj).reverse().join('-')
  }

  static stringify (p) {
    const name = `${p.firstName} ${p.lastName}`
    const address = Address.stringify(p.address)
    const dob = Person.getDobString(p)
    return [name, address, dob].join(' - ')
  }

  toJSON () {
    const cloneObj = {...this}
    cloneObj.name = this.name
    cloneObj.isCompany = this.isCompany
    delete cloneObj.isCompanyVal
    return cloneObj
  }
}
